module.exports = __webpack_public_path__ + "img/autocomplete.64fc2b55.png";